















































































import { Component, Vue } from "vue-property-decorator";
import { Toast, Swipe, SwipeItem } from "vant";
import request from "@/api/jiangjin/index";
import { wxChatShare } from "@/common/wechat";
import Videojs from "video.js";
import "video.js/dist/video-js.css";
import Base from "@/template/public/Base.vue";
import { os } from "@/common/Utils";
import { getData, time } from "@/common/dataCollect";
@Component({
  components: {
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem
  }
})
export default class ScreenVideo extends Base {
  private videolist: Array<object> | any = [];
  private id: string = "";
  private appIdScreen: string = "";
  public request = new request();
  private state: boolean = false;
  private url: string = "";
  private img: string = "";
  private isShow: boolean = true;
  // 埋点
  startTime: string = "";
  endTime: string = "";
  dataSource = true;
  created() {
    this.startTime = time();
  }
  mounted() {
    this.id = (this.$route.query.id as string) || "";
    this.appIdScreen = (this.$route.query.appId as string) || "";
    this.getVideo();
  }
  getVideo() {
    //获取短视频信息 短视频详情必传appid
    this.request.getVideo(this.appIdScreen, this.id).then(res => {
      if (res.code == 0 && res.data) {
        this.videolist = res.data;
        if (this.videolist) {
          if (os().isPc) {
            this.url = this.videolist.videoUrl;
          } else {
            this.url = this.videolist.videoUrl;
          }
          this.img = this.videolist.videoImg;
          this.$nextTick(() => {
            this.initVideo();
          });
          // 唤醒头部 赋值base.vue里detailGetAppId参数值
          this.getBaseappInfoConfigList(this.videolist.appId);
          this.detailGetAppId = this.videolist.appId;
          wxChatShare(
            this.videolist.shareTitle,
            this.videolist.shareDescription,
            this.videolist.shareUrlWx,
            this.videolist.shareImgUrl
          );
          this.$nextTick(() => {
            this.request.addViewCountScreen(this.id, "41").then(res => {
              if (res.data) {
                this.videolist.praiseCount = res.data.praiseCount || 0;
                this.videolist.replyCount = res.data.replyCount || 0;
                this.videolist.viewCountStr = res.data.viewCount || 0;
              }
            });
            // 埋点
            this.endTime = time();
            if (this.dataSource) {
              getData(this.startTime, this.endTime, this.videolist);
              this.dataSource = false;
            }
          });
        }
      }
    });
  }
  //初始化video
  async initVideo() {
    var _this = this;
    let myPlayer = Videojs(
      document.getElementById("myVideo"),
      {
        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: true,
        //自动播放属性,muted:静音播放
        autoplay: false,
        //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: "auto",
        // poster: this.videolist.videoImg,
        loop: false,
        // poster: this.img,
        // 控制器空间显示与否
        controlBar: {
          // playToggle:false, // 播放按钮
          // fullscreenToggle: false,  // 全屏按钮
          // volumePanel: false,  // 音量控制
          children: [
            {
              name: "progressControl"
            }
          ]
        },
        sources: {
          src: this.url.replace("http:", "https:"),
          type: "video/mp4"
        }
      },
      function() {
        myPlayer.on("ended", function() {
          console.log("ended");
          let play = document.getElementById("playImg") as HTMLImageElement;
          play.style.opacity = "1";
          _this.state = false;
        });
      }
    );
    var btn = document.getElementsByClassName(
      "vjs-big-play-button"
    )[0] as HTMLButtonElement;
    btn.style.opacity = "0";
    var bar = document.getElementsByClassName(
      "vjs-control-bar"
    )[0] as HTMLButtonElement;
    bar.style.opacity = "1";
    bar.style.backgroundColor = "transparent";
    let play = document.getElementById("playImg") as HTMLImageElement;
    play.style.opacity = "1";
    let posterImg = document.getElementById("posterImg") as HTMLImageElement;
    posterImg.style.opacity = "1";
  }
  //点击视频
  handle() {
    var myPlayer = Videojs(document.getElementById("myVideo"));
    var meng = document.getElementById("meng") as HTMLDivElement;
    let play = document.getElementById("playImg") as HTMLImageElement;
    let posterImg = document.getElementById("posterImg") as HTMLImageElement;
    let stop = document.getElementById("playStop") as HTMLImageElement;
    //视频在播放时
    if (this.state) {
      myPlayer.pause(); //暂停
      console.log("暂停");
      meng.style.zIndex = "1000";
      meng.style.backgroundColor = "rgba(255, 255, 255, 0)";
      play.style.opacity = "1";
      posterImg.style.opacity = "0";
      stop.style.opacity = "0";
      this.state = false;
    } else {
      myPlayer.play(); //播放视频
      console.log("播放");
      meng.style.zIndex = "";
      play.style.opacity = "0";
      posterImg.style.opacity = "0";
      stop.style.opacity = "1";
      this.state = true;
      setTimeout(() => {
        stop.style.opacity = "0";
      }, 1500);
    }
  }
  //点击右边三个按键跳下载页面
  download() {
    window.location.href = this.videolist.downloadUrl;
  }
  // 唤醒app
  openAppScreen() {
    const shareInfo = this.shareInfo;
    if (!shareInfo.schemeUrl) {
      return (location.href = this.videolist.downloadUrl);
    }
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      const Params = {
        id: this.id,
        sourceId: this.id,
        sourceType: "1",
        url: location.href,
        shareUrl: location.href
      };
      location.href = `${shareInfo.schemeUrl}/info/install/${this.videolist.appId}.html?id=${this.id}&&&sourceId=${this.id}&&&sourceType=1&&&url=${location.href}&&&shareUrl=`;
    } else if (/(Android)/i.test(navigator.userAgent)) {
      const Params = {
        id: this.id,
        sourceId: this.id,
        sourceType: "1",
        url: location.href,
        shareUrl: location.href
      };
      location.href =
        shareInfo.schemeUrl.replace("http://", "").replace("com/", "com") +
        "://" +
        `?params=${JSON.stringify(Params)}`;
      setTimeout(() => {
        location.href = this.videolist.downloadUrl;
      }, 3000);
    } else {
      location.href = this.videolist.downloadUrl;
    }
  }
  closeScreen() {
    this.isShow = false;
  }
}
